var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeIdSaturationWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92451 7.08281C11.1948 6.4745 13.5065 7.14654 15.0929 8.65631C13.9842 8.32936 12.7754 8.29407 11.5781 8.61488C8.1106 9.544 6.05281 13.1082 6.98193 16.5757C7.30274 17.773 7.9377 18.8022 8.77437 19.5984C6.67448 18.9799 4.93663 17.3139 4.32832 15.0437C3.3992 11.5761 5.45698 8.01193 8.92451 7.08281Z",
    fill: "#CFD0D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1263 17.9685C12.856 18.5768 10.5443 17.9047 8.95786 16.395C10.0666 16.7219 11.2754 16.7572 12.4727 16.4364C15.9402 15.5073 17.998 11.9431 17.0688 8.47555C16.748 7.27827 16.1131 6.24907 15.2764 5.45285C17.3763 6.0714 19.1141 7.73736 19.7225 10.0076C20.6516 13.4751 18.5938 17.0393 15.1263 17.9685Z",
    fill: "#CFD0D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeIdSaturationWhite);
export default __webpack_public_path__ + "static/media/life_id-saturation-white.9898a86f40584a007bf41ef493622bae.svg";
export { ForwardRef as ReactComponent };